import Toggles from "@domain/toggles/Toggles"
import Article from "../catalog/Article"
import ArticleCollection from "../catalog/ArticleCollection"
import BaseBOM from "../catalog/BaseBOM"
import CreationBOM from "../catalog/CreationBOM"
import RegularBOM from "../catalog/RegularBOM"
import Space, { Configurator, Source } from "../composition/Space"
import Complement from "@domain/composition/Complement"
import Light from "@domain/composition/Light"
import { ClusterElement } from "@domain/composition/Cluster"
import Base from "@domain/composition/Base"
import Group, { ComposableElement } from "@domain/composition/Group"


export function getArticles(articleCollection: ArticleCollection, lights) {
	return lights.map(light => {
		const article = articleCollection.getLightArticle(light.element)
		if (!article)
			throw new Error('No article for this model was found')

		return article
	})
}

export const convertSpaceToBOM = (space: Space, articleCollection: ArticleCollection) => {
	let articles: Article[]

	let elements: Array<ClusterElement<Light | Complement>> = space.getLights()
	const complements = space.getComplements()
	elements = [...elements, ...complements]
	articles = getArticles(articleCollection, elements)

	let BOM: BaseBOM;
	if (!articles.length)
		throw new Error('No articles found in this space')
	if (articles.length > 1) {
		BOM = CreationBOM.fromArticles(articles, space)
	} else {
		BOM = RegularBOM.fromArticle(articles[0], space)
	}

	const productId = space.getProductId()
	if (productId) {
		BOM.setId(productId)
	}

	return BOM
}

export const convertDomainElementsToRegularBOMs = (domainElements: Array<ComposableElement<Base>>, articleCollection: ArticleCollection, configurator?: Configurator, source?: Source) => {
	const result: Array<{ space: Space, bom: RegularBOM }> = []

	const vGroup = new Group(domainElements, null, true)
	const groupedElementsByReference = vGroup.groupArticlesByReference() as Array<Array<Light | Complement>>
	for (let sameReferenceElements of groupedElementsByReference) {
		const element = sameReferenceElements[0]
		const quantity = sameReferenceElements.length

		//@ts-ignore
		const article = articleCollection?.getLightArticle(element)
		if (!article)
			throw new Error('No article for this model was found')

		const composableElements = [{ element, options: { position: [0, 0, 0] } }]
		const spaceToSave = new Space(composableElements, undefined, undefined, undefined, undefined, undefined, undefined, configurator, source)

		const BOM = RegularBOM.fromArticle(article, spaceToSave)
		BOM.props.quantity = quantity

		result.push({ space: spaceToSave, bom: BOM })
	}

	return result
}

export const convertJSONtoBOM = (json: any) => {
	switch (json?.type) {
		case 'CREATION':
			return new CreationBOM(json)
		default: //REGULAR
			return new RegularBOM(json)
	}
}


export default {
	convertSpaceToBOM,
	convertJSONtoBOM,
	convertDomainElementsToRegularBOMs
}